import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import PublicLayout from "@/components/PublicLayout";
import { ArticleCard, ReportCard, CompanyCard } from "@/components/Cards";

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [data, setData] = useState({ articles: [], companies: [], reports: [] });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!q || q.length < 2) return;
    setLoading(true);
    api.get(`/search?q=${encodeURIComponent(q)}`).then((r) => setData(r.data)).finally(() => setLoading(false));
  }, [q]);

  return (
    <PublicLayout>
      <section className="border-b border-[var(--ink)] bg-[var(--parchment)] py-20">
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="eyebrow">Search</div>
          <h1 className="font-display font-black text-[clamp(2.2rem,5vw,4rem)] mt-4 leading-[0.95]">Results for "{q}"</h1>
          {loading && <div className="mt-8 font-mono text-sm">Searching…</div>}

          {data.articles?.length > 0 && (
            <div className="mt-12">
              <div className="eyebrow">Articles · {data.articles.length}</div>
              <div className="mt-6 grid md:grid-cols-3 gap-6">{data.articles.map((a) => <ArticleCard key={a.slug} article={a} />)}</div>
            </div>
          )}
          {data.reports?.length > 0 && (
            <div className="mt-12">
              <div className="eyebrow">Research · {data.reports.length}</div>
              <div className="mt-6 grid md:grid-cols-3 gap-6">{data.reports.map((r) => <ReportCard key={r.slug} report={r} />)}</div>
            </div>
          )}
          {data.companies?.length > 0 && (
            <div className="mt-12">
              <div className="eyebrow">Companies · {data.companies.length}</div>
              <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">{data.companies.map((c) => <CompanyCard key={c.slug} company={c} />)}</div>
            </div>
          )}
          {!loading && !data.articles?.length && !data.reports?.length && !data.companies?.length && (
            <div className="mt-12 text-[var(--ink-soft)]">No matches found. Try a different term.</div>
          )}
        </div>
      </section>
    </PublicLayout>
  );
}
